export default function convertHexToRgba(hex: string, alpha = 1) {
  const validRegexpMatchArray = hex.match(/\w\w/g);
  if (!validRegexpMatchArray) return hex;

  const [r, g, b] = validRegexpMatchArray.map(val => parseInt(val, 16));

  return `rgba(${r},${g},${b},${alpha})`;
}
